import { render } from "./TopPart.vue?vue&type=template&id=5b45931a&scoped=true"
import script from "./TopPart.vue?vue&type=script&lang=js"
export * from "./TopPart.vue?vue&type=script&lang=js"

import "./TopPart.vue?vue&type=style&index=0&id=5b45931a&lang=scss&scoped=true"

import exportComponent from "/Users/waiting/Desktop/代码库/musich5/代码/musicweapons/frontend/music/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b45931a"]])

export default __exports__